var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistFederalAssistBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#1829a4",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v101.708m429.582 0V0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 54.953 368.508)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.414 9.354-2.154 21.458 7.199 26.873L235.072 158.43c3.118 1.814 6.974 2.693 10.8 2.693 3.856 0 7.682-.879 10.8-2.693L484.545 26.873c9.383-5.415 12.614-17.519 7.2-26.873-5.386-9.383-17.49-12.614-26.844-7.2L245.872 119.254 26.872-7.2C17.489-12.614 5.414-9.383 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(10.12 342.089)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-228.241c-2.524 0-4.593 2.069-4.593 4.592v27.44c0 2.523 2.069 4.592 4.593 4.592h487.804c2.523 0 4.592-2.069 4.592-4.592V4.592c0-2.523-2.069-4.592-4.592-4.592H34.61",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(240.345 8.789)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h226.2c2.523 0 4.592-2.069 4.592-4.592v-27.44c0-2.523-2.069-4.592-4.592-4.592h-487.804c-2.524 0-4.593 2.069-4.593 4.592v27.44c0 2.523 2.069 4.592 4.593 4.592h228.241",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(273.708 235.619)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.97v-28.261c0-2.438-2.013-4.451-4.45-4.451H4.45c-2.437 0-4.45 2.013-4.45 4.451z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(35.318 198.995)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.97v28.233c0 2.466-2.013 4.479-4.45 4.479H4.45c-2.437 0-4.45-2.013-4.45-4.479Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(35.318 45.413)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.295 78.125h66.018v88.158H56.295Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.998v-28.261c0-2.438-2.013-4.451-4.478-4.451H4.479C2.013-32.712 0-30.699 0-28.261Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(201.992 198.995)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.998v28.233a4.489 4.489 0 0 1-4.478 4.479H4.479A4.489 4.489 0 0 1 0 28.233Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(201.992 45.413)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.997 78.125h65.989v88.158h-65.989z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.998v-28.261c0-2.438-2.013-4.451-4.478-4.451H4.479C2.013-32.712 0-30.699 0-28.261Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(368.694 198.995)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.998v28.233a4.489 4.489 0 0 1-4.478 4.479H4.479A4.489 4.489 0 0 1 0 28.233Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(368.694 45.413)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.699 78.125h65.989v88.158h-65.989z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c13.209 0 24.009 10.8 24.009 24.01 0 13.209-10.8 24.01-24.009 24.01-13.237 0-24.009-10.801-24.009-24.01C-24.009 10.8-13.237 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(257.097 368.99)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-7.401-6.001-13.402-13.402-13.402-3.671 0-16.918-.059-16.918-.059v26.863h16.918C-6.001 13.402 0 7.402 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(161.296 317.92)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-8.658-7.019-15.677-15.677-15.677-4.294 0-19.873-.07-19.873-.07v31.425h19.873C-7.019 15.678 0 8.659 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(166.525 288.824)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 21.87 57.423c.447 1.093 1.994 1.095 2.442.003L45.984 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(194.741 273.078)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32.453",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(201.561 287.38)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v58.135L39.305 1.22c.728-1.053 1.508-.537 1.508.743l-.543 56.281",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(271.33 273.078)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-58.972",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(348.928 332.05)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-29.835-27.424L2.094-58.228",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(380.65 331.306)",
    fill: "none",
    stroke: "#1829a4",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: "",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistFederalAssistBill);
export default __webpack_public_path__ + "static/media/assist-federal-assist-bill.7f6bb955698f9f23317241081e45ce79.svg";
export { ForwardRef as ReactComponent };